/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CreateClearanceCaseResponseJson } from './create-clearance-case-response-json';
import { GenericClearanceCaseResult } from '../results/generic-clearance-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CreateClearanceCaseResponse extends ResponseWithErrorGeneric<CreateClearanceCaseResponseJson, GenericClearanceCaseResult> implements IResponseWithErrorGeneric<GenericClearanceCaseResult> {
  public caseId: string = undefined;
  public clearanceCaseId: string = undefined;
  public clearanceCase: ClearanceCaseDto;

  //<custom-body>
  constructor(response: HttpResponse<CreateClearanceCaseResponse>) {
    super(response, GenericClearanceCaseResult.Error);
    if (this.result !== GenericClearanceCaseResult.Success) {
      return;
    }
    
    this.caseId = this.body.caseId;
    this.clearanceCaseId = this.body.clearanceCaseId;
    this.clearanceCase = this.body.clearanceCase ? new ClearanceCaseDto(this.body.clearanceCase, null) : this.body.clearanceCase;
  }
  //</custom-body>
}
